module.exports = __webpack_public_path__ + "static/media/error.66afcaa0.svg";